import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';

const LoungeGallery = ({ galleryImages }) => {
  const centerIndex = Math.floor(galleryImages.length / 2);

  return (
    <div className="relative bg-[#1B1F3B] text-white min-h-fit p-6 overflow-hidden">

      {/* Gradient Accent */}
      <div className="h-1 w-full my-10 bg-gradient-to-r from-[#D4AF37] via-transparent to-[#D4AF37] rounded-full"></div>

      {/* Centered Carousel Gallery */}
      <Swiper
        modules={[Autoplay]}
        spaceBetween={20}
        slidesPerView={1} // default for mobile
        centeredSlides={true}
        initialSlide={centerIndex}
        loop={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        className="mb-10"
        breakpoints={{
          768: { slidesPerView: 3, spaceBetween: 20 }, // md and up → 3 images
          1024: { slidesPerView: 3, spaceBetween: 20 }, // laptops/desktops
        }}
      >
        {galleryImages.map((img, idx) => (
          <SwiperSlide key={idx} className="transition-transform duration-500">
            {({ isActive }) => (
              <div
                className={`relative overflow-hidden rounded-lg transition-transform duration-500 ${
                  isActive
                    ? 'scale-110 opacity-100 shadow-2xl'
                    : 'scale-95 opacity-70 shadow-lg'
                }`}
              >
                <img
                  src={img}
                  alt={`Lounge ${idx + 1}`}
                  className="w-full h-64 md:h-80 object-cover transform transition-transform duration-500"
                />
              </div>
            )}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default LoungeGallery;